<template>
  <!-- ========== ========== Parent iFrame ========== ========== -->
  <!-- <div style="width: 100%; min-height: 120px; position: relative">
    <iframe
      ref="SurveyAnswer"
      src="/survey-answer-page"
      style="width: 100%; height: 100%; border: none"
      @load="handleSendMessageSurveyAnswer"
    ></iframe>
    <LoadingType1 v-if="loadingSchema" />
  </div> -->
  <v-row ref="container" no-gutters>
    <v-col cols="12" class="pa-0">
      <div ref="containerSurvey" style="width: 100%">
        <Survey
          v-if="survey"
          :survey="survey"
          style="height: fit-content; z-index: 1; border-radius: 8px"
        >
        </Survey>
      </div>
    </v-col>
    <v-col
      v-if="useButtonSubmit"
      cols="12"
      class="py-0 pb-0 d-flex justify-end"
    >
      <v-btn class="ma-0 mt-2" color="info" @click="handleSubmit">
        Submit
      </v-btn>
    </v-col>
  </v-row>
</template>
  
<script>
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import Axios from "@/config/customer-service";
import { addClassQlEditorToSDDisplay } from "@/config/general-function";
import _ from "lodash";
import { provinces } from "../../../config/location/provinces.js";
import { districts } from "../../../config/location/districts.js";
import { sub_districts } from "../../../config/location/sub_districts.js";
import {
  addDivCustomInputMaskPattern,
  formattedForSave,
  transformJsonCustomInputMask,
} from "../../../config/general-function.js";

export default {
  inject: ["isAppLoading"],
  props: {
    isUseIFrame: { default: true },
    propSchema: { default: () => {} },
    propSchemaDetail: { default: () => {} },
    propUseButtonSubmit: { default: false },
    propListBrandsBranches: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["onSubmit", "onValueChange"],
  components: {
    Survey,
  },
  data() {
    return {
      survey: null,

      list_brands_branches: [],

      useButtonSubmit: false,
    };
  },
  async created() {
    // ========== ========== iframe ========== ==========
    if (this.isUseIFrame) {
      window.addEventListener("message", this.handleMessage);
      setTimeout(() => {
        if (this.$refs.containerSurvey) {
          const offsetHeight = this.$refs.containerSurvey.offsetHeight;
          window.parent.postMessage(
            { type: "onUpdateHeight", data: offsetHeight },
            "*"
          );
        }
      }, 1000);
    }
    // ========== ========== ========== =========
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    // ========== ========== Function For Parent iFrame ========== ==========
    handleSendMessageSurveyAnswer() {
      if (!this.$refs.SurveyAnswer) return;
      this.$refs.SurveyAnswer.contentWindow.postMessage(
        {
          type: "props",
          data: {
            propSchema: null,
            propUseButtonSubmit: false,
          },
        },
        "*"
      );
      // this.loadingSchema = false;
    },
    async handleExternalSubmit() {
      const channel = new MessageChannel();

      // สร้าง Promise มารอคำตอบจากช่อง port1
      const waitReply = new Promise((resolve) => {
        channel.port1.onmessage = (event) => {
          resolve(event.data);
        };
      });

      // ส่งข้อมูลไปพร้อมกับแนบ port2 ไปให้ Iframe ใช้ตอบกลับ
      this.$refs.SurveyAnswer.contentWindow.postMessage(
        {
          type: "externalSubmit",
          data: null,
        },
        "*",
        [channel.port2] // แนบท่อส่งกลับไปด้วย
      );

      const result = await waitReply;
      console.log("ตอบกลับมาแล้ว:", result);
      return result;
    },
    handleMessageForParent(event) {
      const senderWindow = event.source;
      if (event.data.type === "onUpdateHeight") {
        if (event.data.data) {
          const heightSchema = event.data.data;
          console.log(heightSchema);
          const SurveyAnswer = this.$refs.SurveyAnswer?.contentWindow;
          if (senderWindow === SurveyAnswer) {
            console.log("Match");
          } else {
            console.log("Not Found [SurveyAnswer]");
          }
        }
      }
    },
    // ========== ========== ========== ==========
    async handleMessage(event) {
      if (event.data.type === "props") {
        const data = event.data.data || null;
        this.useButtonSubmit =
          typeof data?.propUseButtonSubmit != "boolean"
            ? this.useButtonSubmit
            : data?.propUseButtonSubmit;
        this.list_brands_branches = data?.propListBrandsBranches || [];
        this.resetSurvey(data?.propSchema, data?.propSchemaDetail);
      } else if (event.data.type === "externalSubmit") {
        const replyPort = event.ports[0];
        if (replyPort) {
          const result = await this.handleSubmit();
          const success = result ? true : false;
          replyPort.postMessage({ success: success, data: result });
        }
      } else if (event.data.type === "getCurrentData") {
        const replyPort = event.ports[0];
        if (replyPort) {
          const result = this.survey.data;
          replyPort.postMessage({ data: result });
        }
      }
    },
    onValueChanged() {
      const _isAppLoading = (param) => {
        this.isAppLoading(param);
      };
      this.survey.onValueChanged.add((sender, options) => {
        const name = options.name;
        const value = options.value;
        const questions = this.survey.getAllQuestions();
        const detail = {
          name: name,
          value: value,
        };
        // ========== ========== Set Null Value Invisible Question ========== ==========
        const invisible_questions = questions.filter((x) => !x.visible);
        for (let invisible_question of invisible_questions) {
          const _name = invisible_question.name;
          const model = this.survey.getQuestionByName(_name);
          if (model) {
            this.survey.setValue(_name, null);
          }
        }
        // ========== ========== Address ========== ==========
        if (name == "province") {
          const district = this.survey.getQuestionByName("district");
          if (district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = districts
                .filter((x) => x.province_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            district.readOnly = readOnly;
            district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = district.page;
            page.removeElement(district);
            setTimeout(() => {
              const _province = this.survey.getQuestionByName("province");
              const _page = _province.page;
              const originalIndex = _page.elements.indexOf(_province);
              this.survey.setValue("district", null);
              _page.addElement(district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "district") {
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = sub_districts
                .filter((x) => x.district_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            sub_district.readOnly = readOnly;
            sub_district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = sub_district.page;
            page.removeElement(sub_district);
            setTimeout(() => {
              const _district = this.survey.getQuestionByName("district");
              const _page = _district.page;
              const originalIndex = _page.elements.indexOf(_district);
              this.survey.setValue("sub_district", null);
              _page.addElement(sub_district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "sub_district") {
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code) {
            let list = [];
            let readOnly = true;
            let _value = null;
            if (value) {
              readOnly = false;
              const model = sub_districts.find((x) => x.id == value);
              const zip_codes = model?.zip_codes || [];
              if (zip_codes.length > 0) {
                _value = `${model.id}_${zip_codes[0]}`;
              }
              for (let item of zip_codes) {
                list.push({
                  value: `${model.id}_${item}`,
                  text: `${item}`,
                });
              }
            }
            zip_code.readOnly = readOnly;
            zip_code.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = zip_code.page;
            page.removeElement(zip_code);
            setTimeout(() => {
              const _sub_district =
                this.survey.getQuestionByName("sub_district");
              const _page = _sub_district.page;
              const originalIndex = _page.elements.indexOf(_sub_district);
              this.survey.setValue("zip_code", _value);
              _page.addElement(zip_code, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        // ========== ========== Brand Branch ========== ==========
        const branch_brand_first_questions =
          questions.find((x) => ["branch", "brand"].includes(x.name))?.name ||
          "";
        if (name == branch_brand_first_questions) {
          const second_question =
            branch_brand_first_questions == "branch" ? "brand" : "branch";
          const second = this.survey.getQuestionByName(second_question);
          if (second) {
            let is_same_page = true;
            const first = this.survey.getQuestionByName(
              branch_brand_first_questions
            );
            if (first.page.name != second.page.name) {
              is_same_page = false;
            }
            let list = [];
            let visible = false;
            if (value) {
              visible = true;
              const brands_branches = this.list_brands_branches || [];
              const choice = brands_branches
                .filter(
                  (x) =>
                    x[`${branch_brand_first_questions}_name`] == value &&
                    x[`${second_question}_name`]
                )
                .map((x) => x[`${second_question}_name`]);
              const grouped = Object.groupBy(choice, (item) => item);
              list = Object.keys(grouped);
            }
            second.visible = visible;
            if (list.length == 0) {
              second.visible = false;
            }
            second.choices = list;
            // const oldSecondValue = this.survey.getValue(second_question);
            // ========== ========== ========== ==========
            if (is_same_page) {
              _isAppLoading(true);
              // const page = second.page;
              // page.removeElement(second);
              setTimeout(() => {
                // const _first = this.survey.getQuestionByName(
                //   branch_brand_first_questions
                // );
                // const _page = _first.page;
                // const originalIndex = _page.elements.indexOf(_first);
                // _page.addElement(second, originalIndex + 1);
                this.survey.setValue(second_question, null);
                // if (oldSecondValue && list.includes(oldSecondValue)) {
                //   this.survey.setValue(second_question, oldSecondValue);
                // } else {
                //   this.survey.setValue(second_question, null);
                // }
                _isAppLoading(false);
              }, 100);
            }
          }
        }
        // ========== ========== onValueChange ========== ==========
        if (this.isUseIFrame) {
          window.parent.postMessage(
            { type: "onValueChange", data: detail },
            "*"
          );
        } else {
          this.$emit("onValueChange", detail);
        }
      });
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    onUploadFiles() {
      this.survey.onUploadFiles.add(function (_, options) {
        options.files.forEach(function (file) {
          const formData = new FormData();
          formData.append("image", file);
          formData.append("module", "SurveyAnswer");

          Axios.post("/uploadImageDefault", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                const url = data.data?.url || data.image_url;
                options.callback("success", [
                  {
                    file: file,
                    content: url,
                  },
                ]);
              }
            })
            .catch((err) => {
              throw err;
            });
        });
      });
    },
    setQuestionBrandBranch(schema) {
      let pages = schema?.pages || [];
      const brands_branches = this.list_brands_branches || [];
      let first_question = "";
      let second_question = "";
      let flat_question = [];
      let is_same_page = true;
      const setBrandBranch = (elements) => {
        second_question = first_question == "branch" ? "brand" : "branch";
        if (Array.isArray(elements)) {
          const first = elements.find((x) => x.name == first_question);
          if (first) {
            const first_choice = brands_branches
              .filter((x) => x[`${first_question}_name`])
              .map((x) => x[`${first_question}_name`]);
            const grouped = Object.groupBy(first_choice, (item) => item);
            first.choices = Object.keys(grouped);
          }
          // ========== ========== ========== ==========
          const second = elements.find((x) => x.name == second_question);
          if (second && is_same_page) {
            second.visible = false;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let element = item.elements.map((x) => {
            return {
              ...x,
              page: item.name,
            };
          });
          if (Array.isArray(element)) {
            flat_question = [...flat_question, ...element];
          }
        }
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        const branch = flat_question.find((x) => ["branch"].includes(x.name));
        const brand = flat_question.find((x) => ["brand"].includes(x.name));
        if (branch && brand) {
          if (branch.page != brand.page) {
            is_same_page = false;
          }
        }
        if (first_question) {
          for (let item of pages) {
            let elements = item?.elements || [];
            elements = setBrandBranch(elements);
            if (item) {
              item.elements = elements;
            }
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        flat_question = [...elements];
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        elements = setBrandBranch(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    setQuestionAddress(schema) {
      let pages = schema?.pages || [];
      const setAddress = (elements) => {
        if (Array.isArray(elements)) {
          const province = elements.find((x) => x.name == "province");
          if (province) {
            province.choices = provinces.map((x) => {
              return {
                value: x.id,
                text: x.name_th,
              };
            });
          }
          // ========== ========== ========== ==========
          const district = elements.find((x) => x.name == "district");
          if (district) {
            district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const sub_district = elements.find((x) => x.name == "sub_district");
          if (sub_district) {
            sub_district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const zip_code = elements.find((x) => x.name == "zip_code");
          if (zip_code) {
            zip_code.readOnly = true;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let elements = item?.elements || [];
          elements = setAddress(elements);
          if (item) {
            item.elements = elements;
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        elements = setAddress(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    async setAnswer(schema_detail) {
      const sleep = async (msec) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, msec || 500);
        });
      };
      if (this.survey && schema_detail) {
        for (const key in schema_detail) {
          await sleep(100);
          const question = this.survey.getQuestionByName(key);
          if (question) {
            this.survey.setValue(key, schema_detail[key]);
          }
        }
      }
    },
    resetSurvey(schema, schema_detail) {
      this.survey = null;
      if (schema) {
        let json = _.cloneDeep(schema);
        json = this.setQuestionBrandBranch(json);
        json = this.setQuestionAddress(json);
        json = transformJsonCustomInputMask(json);
        this.survey = new Model(json);
        this.survey.showCompletedPage = false;
        if (!this.useButtonSubmit) {
          this.survey.showNavigationButtons = false;
        }
        // this.handleSubmit();
        this.onValueChanged();
        this.onAfterRenderPage();
        this.onAfterRenderQuestion();
        this.onUploadFiles();
        // ========== ========== ========== ==========
        if (schema_detail && Object.keys(schema_detail).length > 0) {
          this.setAnswer(schema_detail);
        }
      }
      if (this.isUseIFrame) {
        setTimeout(() => {
          if (this.$refs.containerSurvey) {
            const offsetHeight = this.$refs.containerSurvey.offsetHeight;
            window.parent.postMessage(
              { type: "onUpdateHeight", data: offsetHeight },
              "*"
            );
          }
        }, 1000);
      }
    },
    getCurrentData() {
      const result = this.survey.data;
      return result;
    },

    // ========== ========== ========== ==========
    async handleSubmit() {
      const isSurveyHasErrors = this.survey.hasErrors();
      if (isSurveyHasErrors) {
        return null;
      }
      const result = await this.onSubmit();
      return result;
    },
    async onSubmit() {
      this.isAppLoading(true);
      const result_json = this.survey.data;
      // ========== Upload Image ==========
      for (const key in result_json) {
        let value = result_json[key];
        if (
          typeof value == "object" &&
          JSON.stringify(value).includes(";base64,")
        ) {
          for (let _item of result_json[key]) {
            if (_item.name && _item.content) {
              const file = await this.convertBase64ToFile(
                _item.content,
                _item.name
              );
              const url = await this.uploadImage(file);
              if (url) {
                _item.content = url;
              }
            }
          }
        }
      }
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(this.survey.jsonObj, result_json);
      // ========== ========== ========== ==========
      if (this.useButtonSubmit) {
        if (this.isUseIFrame) {
          window.parent.postMessage(
            { type: "onUpdateSchema", data: this.creator.JSON },
            "*"
          );
        } else {
          this.$emit("onSubmit", formatJson);
        }
      }
      this.isAppLoading(false);
      return formatJson;
    },

    // ========== Upload Image ==========
    convertBase64ToFile(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            const image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            resolve(image);
          })
          .catch((err) => {
            console.log("convertBase64ToFile", err);
            resolve(null);
          });
      });
    },
    async uploadImage(file) {
      let responseReturn = null;
      const formData = new FormData();
      formData.append("image", file);
      formData.append("module", "SurveyAnswer");
      const response = await Axios.post(`uploadImageDefault`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.status == "success") {
        const url = response.data.data?.url || response.data.image_url;
        responseReturn = url;
      }
      return responseReturn;
    },
  },
  computed: {},
  watch: {
    propSchema: {
      handler() {
        if (!this.isUseIFrame) {
          this.list_brands_branches = this.propListBrandsBranches || [];
          this.resetSurvey(this.propSchema, this.propSchemaDetail);
        }
      },
      deep: true,
      immediate: true,
    },
    propUseButtonSubmit: {
      handler() {
        if (!this.isUseIFrame) {
          this.useButtonSubmit = this.propUseButtonSubmit;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
  
<style scoped>
</style>